import { StatelessComponent } from 'react'
import RadioButtonList, { RadioButtonListProps } from 'components/atoms/inputs/RadioButtonList'
import { prepareFieldErrors } from 'helpers/formHelpers'
import { WrappedFieldProps, WrappedFieldInputProps } from 'redux-form'
import { State } from 'interfaces/state'
import { QAMarked } from 'interfaces/component'

type RadioButtonListWrappedProps =
  & WrappedFieldProps<State>
  & QAMarked
  & RadioButtonListProps

const RadioButtonListWrapped: StatelessComponent<RadioButtonListWrappedProps> = (props) => {
  const { touched, error } = props.meta
  const input = props.input as WrappedFieldInputProps
  const errorItem = prepareFieldErrors(error, touched)[0]

  return (
    <RadioButtonList
      { ...props }
      { ...input }
      error={ errorItem ? errorItem.text : undefined }
    />
  )
}

export default RadioButtonListWrapped
